import React from 'react';
import styles from '../styles/CustomRangeSlider.module.css';

const CustomRangeSlider = ({ min, max, value, onChange }) => {
  const [minVal, maxVal] = value;

  const handleMinChange = (e) => {
    const newVal = Math.min(+e.target.value, maxVal - 1);
    onChange([newVal, maxVal]);
  };

  const handleMaxChange = (e) => {
    const newVal = Math.max(+e.target.value, minVal + 1);
    onChange([minVal, newVal]);
  };

  const minPercent = ((minVal - min) / (max - min)) * 100;
  const maxPercent = ((maxVal - min) / (max - min)) * 100;

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.sliderTrack}
        style={{
          '--minPos': `${minPercent}%`,
          '--maxPos': `${maxPercent}%`
        }}
      >
        <input
          type="range"
          min={min}
          max={max}
          value={minVal}
          onChange={handleMinChange}
          className={styles.thumb}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={maxVal}
          onChange={handleMaxChange}
          className={styles.thumb}
        />
      </div>
      <div className={styles.inputs}>
        <input
          type="number"
          className={styles.priceInput}
          value={minVal}
          onChange={handleMinChange}
          min={min}
          max={maxVal - 1}
          placeholder="От"
        />
        <input
          type="number"
          className={styles.priceInput}
          value={maxVal}
          onChange={handleMaxChange}
          min={minVal + 1}
          max={max}
          placeholder="До"
        />
      </div>
    </div>
  );
};

export default CustomRangeSlider;
